export const endpoint =
  process.env.REACT_APP_ENDPOINT ||
  "https://9fco0xsqei.execute-api.us-west-2.amazonaws.com/prod";
